import { Button } from '@components/ui/button';
import { SEARCH_HIGHLIGHT_NAV_Z_INDEX } from '@constants/z-indices';
import { cn } from 'cn';
import { ChevronDownIcon, ChevronUpIcon, XIcon } from 'lucide-react';

interface SearchHighlightNavProps {
  activeIndex: number;
  matchCount: number;
  onDismiss: () => void;
  onNext: () => void;
  onPrevious: () => void;
}

export const SearchHighlightNav = ({
  activeIndex,
  matchCount,
  onDismiss,
  onNext,
  onPrevious,
}: SearchHighlightNavProps) => {
  return (
    <div
      className={cn(
        'fixed top-20 right-6 flex items-center gap-1 rounded-md border bg-white px-2 py-1 shadow-md',
        SEARCH_HIGHLIGHT_NAV_Z_INDEX,
      )}
    >
      <span className="text-muted-foreground px-1 text-xs tabular-nums">
        {activeIndex + 1} / {matchCount}
      </span>
      <Button variant="ghost" size="icon-sm" aria-label="Previous match" onClick={onPrevious}>
        <ChevronUpIcon />
      </Button>
      <Button variant="ghost" size="icon-sm" aria-label="Next match" onClick={onNext}>
        <ChevronDownIcon />
      </Button>
      <Button variant="ghost" size="icon-sm" aria-label="Close" onClick={onDismiss}>
        <XIcon />
      </Button>
    </div>
  );
};
